import { render, staticRenderFns } from "./GraphTournamentEmpates.vue?vue&type=template&id=64dd64c9"
import script from "./GraphTournamentEmpates.vue?vue&type=script&lang=js"
export * from "./GraphTournamentEmpates.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports